"use client"

import { useEffect, useRef } from "react"
import { usePathname } from "next/navigation"

export function ScrollRestorationFix() {
  const pathname = usePathname()
  const isStatePopped = useRef(false)

  // Handling the scroll position to ensure clicking on the links
  // scrolls the page to the top with the sticky positioned navbar.
  useEffect(() => {
    const onPopState = () => (isStatePopped.current = true)

    window.addEventListener("popstate", onPopState)
    return () => window.removeEventListener("popstate", onPopState)
  }, [])

  useEffect(() => {
    if (!isStatePopped.current) {
      // navigation occurred without pressing
      // the browser's back or forward buttons
      window.scrollTo({ top: 0, left: 0, behavior: "instant" })
    } else {
      isStatePopped.current = false
    }
  }, [pathname])

  return null
}
